export default __webpack_public_path__ + "static/media/github2.7ba3cf23.png";